<template>
  <div
      style="
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      "
  >
    <div
        style="
          width: 95%;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 20px;
          margin-bottom: 20px;
        "
    >
      <div class="filters-actions-container">
        <form @submit.prevent="searchSessioni" class="filters">
          <v-expansion-panels
              style="width: 250px !important; z-index: 3"
              v-model="this.panelOrdiniResi"
          >
            <v-expansion-panel
                :title="this.filterOrdini && this.filterResi ? 'ORDINI e RESI' : (this.filterOrdini ? 'ORDINI' : (this.filterResi ? 'RESI': 'NULLA'))"
                value="1"
                style="
                width: 250px !important;
                position: absolute;
                border-radius: 5px !important;
                border: thin solid #d0d0d0 !important;
              "
                density="comfortable"
            >
              <v-expansion-panel-text style="width: 250px !important">
                <v-switch
                    v-model="this.filterOrdini"
                    label="ORDINI"
                    color="#2196f3"
                    hide-details
                    style="
                    width: 200px !important;
                    box-shadow: none !important;
                    border-radius: none !important;
                  "
                ></v-switch>
                <v-switch
                    v-model="this.filterResi"
                    label="RESI"
                    color="#2196f3"
                    hide-details
                    style="
                    width: 200px !important;
                    box-shadow: none !important;
                    border-radius: none !important;
                  "
                ></v-switch>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
          <div
              style="
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: end;
                    row-gap: 5px;
                    "
          >
            <v-dialog width="375px">
              <template v-slot:activator="{ props }">
                <v-btn
                    v-bind="props"
                    variant="outlined"
                    text="DATA RICEZIONE"
                    height="48px"
                    width="200"
                ></v-btn>
              </template>
              <template v-slot:default="{ isActive }">
                <v-card title="SELEZIONA DATA RICEZIONE">
                  <div
                      style="
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    "
                  >
                    <v-date-picker
                        style="border: 1px solid #d0d0d0 !important"
                        v-model="this.dataRicezione"
                    ></v-date-picker>
                  </div>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        text="CANCELLA"
                        @click="this.dataRicezione = null"
                        class="bg-red"
                        variant="outlined"
                    ></v-btn
                    >
                    <v-btn
                        text="INVIA"
                        @click="
                                        () => {
                                            searchSessioni();
                                            isActive.value = false;
                                        }"
                        class="bg-green"
                        variant="outlined"
                    ></v-btn>
                  </v-card-actions>
                </v-card>
              </template>
            </v-dialog>
            <small>{{ this.formatDate(this.dataRicezione) }}</small>
          </div>
          <div
              style="
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: end;
                    row-gap: 5px;
                    "
          >
            <v-dialog width="375px">
              <template v-slot:activator="{ props }">
                <v-btn
                    v-bind="props"
                    variant="outlined"
                    text="DATA LAVORAZIONE"
                    height="48px"
                    width="200"
                ></v-btn>
              </template>
              <template v-slot:default="{ isActive }">
                <v-card title="SELEZIONA DATA LAVORAZIONE">
                  <div
                      style="
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    "
                  >
                    <v-date-picker
                        style="border: 1px solid #d0d0d0 !important"
                        v-model="this.dataCreazione"
                    ></v-date-picker>
                  </div>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        text="CANCELLA"
                        @click="this.dataCreazione = null"
                        class="bg-red"
                        variant="outlined"
                    ></v-btn
                    >
                    <v-btn
                        text="INVIA"
                        @click="
                                        () => {
                                            searchSessioni();
                                            isActive.value = false;
                                        }"
                        class="bg-green"
                        variant="outlined"
                    ></v-btn>
                  </v-card-actions>
                </v-card>
              </template>
            </v-dialog>
            <small>{{ this.formatDate(this.dataCreazione) }}</small>
          </div>
          <v-text-field
              density="comfortable"
              variant="outlined"
              label="CERCA UTENTE"
              append-inner-icon="mdi-magnify"
              hide-details
              style="width: 200px !important"
              v-model="searchingUtente.text"
              :clearable="true"
          ></v-text-field>
          <v-text-field
              density="comfortable"
              variant="outlined"
              label="CERCA AWB"
              append-inner-icon="mdi-magnify"
              hide-details
              style="width: 200px !important"
              v-model="searchingAwb.text"
              :clearable="true"
          ></v-text-field>
          <v-btn
              type="submit"
              icon="mdi-magnify"
              class="bg-blue"
              variant="outlined"
          />
          <v-btn
              variant="outlined"
              height="48"
              width="120"
              class="bg-red"
              @click="resetFiltri"
          >RESET FILTRI
          </v-btn
          >
        </form>
      </div>
    </div>
    <div style="width: 95%">
      <v-data-table-server
          :loading="loading"
          v-model:items-per-page-options="options"
          :fixed-header="true"
          :headers="headers"
          :items="this.sessioniServer"
          v-model:items-per-page="itemsPerPage"
          v-model:sort-by="sortBy"
          :items-length="totalItems"
          @update:options="loadItems"
          style="
            width: 100%;
            border: 1px solid #d0d0d0;
            border-radius: 5px;
            max-height: 475px;
            "
      >
        <template v-slot:item.dataRicezione="{ item }">
          <div style="display: flex; align-items: center; column-gap: 5px;">
            <p v-if="item.dataRicezione === null || item.dataRicezione === ''">
              NESSUNA
            </p>
            <p v-else>{{ this.formattaDataOra(item.dataRicezione) }}</p>
            <v-icon
                v-if="isAdmin"
                icon="mdi-pencil"
                size="small"
                color="blue"
                v-tooltip="'Modifica data ricezione'"
                @click="openEditDataRicezione(item)"
            ></v-icon>
          </div>
        </template>
        <template v-slot:item.discordanze="{ item }">
          <div style="display: flex; align-items: center; column-gap: 5px;">
            <p>{{ item.discordanze }}</p>
            <v-icon
                v-if="isAdmin"
                icon="mdi-pencil"
                size="small"
                color="blue"
                v-tooltip="'Modifica discordanze'"
                @click="openEditDiscordanze(item)"
            ></v-icon>
          </div>
        </template>
        <template v-slot:item.extraOut="{ item }">
          <div style="display: flex; align-items: center; column-gap: 5px;">
            <p>{{ item.extraOut }}</p>
            <v-icon
                v-if="isAdmin"
                icon="mdi-pencil"
                size="small"
                color="blue"
                v-tooltip="'Modifica extra out'"
                @click="openEditExtraOut(item)"
            ></v-icon>
          </div>
        </template>
        <template v-slot:item.dataCreazione="{ item }">
          <p v-if="item.dataCreazione === null || item.dataCreazione === ''">
            NESSUNA
          </p>
          <p v-else>{{ this.formattaDataOra(item.dataCreazione) }}</p>
        </template>
        <template v-slot:item.dataAggiornamento="{ item }">
          <p v-if="item.dataAggiornamento === null || item.dataAggiornamento === ''">
            NESSUNA
          </p>
          <p v-else>{{ this.formattaDataOra(item.dataAggiornamento) }}</p>
        </template>
        <template v-slot:item.aperta="{ item }">
          <v-chip v-if="item.aperta" color="green" variant="flat">
            SI
          </v-chip>
          <v-chip v-else color="red" variant="flat"> NO</v-chip>
        </template>
        <template v-slot:item.order="{ item }">
          <v-chip v-if="item.order" color="green" variant="flat">
            ORDINE
          </v-chip>
          <v-chip v-else color="blue" variant="flat">
            RESO
          </v-chip>
        </template>
        <template v-slot:item.id="{ item }">
          <div
              style="
              display: flex;
              justify-content: center;
              align-items: center;
              column-gap: 10px;
            "
          >
            <v-icon
                icon="mdi-information-outline"
                @click="openDetails(item.id)"
                color="blue"
                size="x-large"
                v-tooltip="'Apri dettagli'"
            ></v-icon>
          </div>
        </template>
      </v-data-table-server>
      <div
          style="
            display: flex;
            align-items: center;
            justify-content: start;
            column-gap: 10px;
            margin-bottom: 20px;
            "
      >
        <v-btn
            variant="outlined"
            height="48px"
            style="margin-top: 20px; background-color: #1d6f42; color: white"
            @click="exportExcel"
        >ESPORTA EXCEL
        </v-btn
        >
      </div>
    </div>
    <v-dialog v-model="editDataRicezioneDialog" width="375px">
      <v-card title="MODIFICA DATA RICEZIONE">
        <v-card-subtitle>AWB: {{ editingSession?.awb }}</v-card-subtitle>
        <div style="display: flex; justify-content: center; align-items: center;">
          <v-date-picker
              style="border: 1px solid #d0d0d0 !important"
              v-model="editDataRicezioneValue"
          ></v-date-picker>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              text="ANNULLA"
              @click="editDataRicezioneDialog = false"
              variant="outlined"
          ></v-btn>
          <v-btn
              text="SALVA"
              @click="saveDataRicezione"
              class="bg-green"
              variant="outlined"
              :disabled="editDataRicezioneValue === null"
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editDiscordanzeDialog" width="375px">
      <v-card title="MODIFICA DISCORDANZE">
        <v-card-subtitle>AWB: {{ editingSession?.awb }}</v-card-subtitle>
        <v-card-text>
          <v-text-field
              v-model.number="editDiscordanzeValue"
              type="number"
              min="0"
              label="Numero discordanze"
              variant="outlined"
              hide-details
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              text="ANNULLA"
              @click="editDiscordanzeDialog = false"
              variant="outlined"
          ></v-btn>
          <v-btn
              text="SALVA"
              @click="saveDiscordanze"
              class="bg-green"
              variant="outlined"
              :disabled="!Number.isInteger(editDiscordanzeValue) || editDiscordanzeValue < 0"
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editExtraOutDialog" width="375px">
      <v-card title="MODIFICA EXTRA OUT">
        <v-card-subtitle>AWB: {{ editingSession?.awb }}</v-card-subtitle>
        <v-card-text>
          <v-text-field
              v-model.number="editExtraOutValue"
              type="number"
              min="0"
              label="Extra out"
              variant="outlined"
              hide-details
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              text="ANNULLA"
              @click="editExtraOutDialog = false"
              variant="outlined"
          ></v-btn>
          <v-btn
              text="SALVA"
              @click="saveExtraOut"
              class="bg-green"
              variant="outlined"
              :disabled="!Number.isInteger(editExtraOutValue) || editExtraOutValue < 0"
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {useStore} from "vuex";
import {Icon} from "@iconify/vue";
import Swal from "sweetalert2";

const axios = require("axios");
const {DateTime} = require("luxon");
export default {
  name: "SessionsTable",

  setup() {
    const store = useStore();
    return {
      store,
      dateTime: DateTime,
    };
  },

  components: {
    Icon,
  },

  created() {
    this.dataCreazione = new Date();
  },

  data() {
    return {
      panelOrdiniResi: false,
      searchingUtente: {
        text: "",
      },
      searchingAwb: {
        text: "",
      },
      itemsPerPage: 10,
      totalItems: 0,
      currentPage: 0,
      headers: [
        {title: "AWB INGRESSO", value: "awb", sortable: true},
        {
          title: "DISCORDANZE",
          value: "discordanze",
          sortable: false,
          align: "center",
        },
        {
          title: "PEZZI OUT",
          value: "pezziOut",
          sortable: false,
          align: "center",
        },
        {
          title: "EXTRA OUT",
          value: "extraOut",
          sortable: false,
          align: "center",
        },
        {title: "RICEZIONE", value: "dataRicezione", sortable: true},
        {title: "PRIMA LAVORAZIONE", value: "dataCreazione", sortable: true},
        {
          title: "ULTIMA LAVORAZIONE",
          value: "dataAggiornamento",
          sortable: true,
        },
        {
          title: "OPERATORE",
          value: "creatore",
          sortable: false,
        },
        {title: "APERTA", value: "aperta", sortable: false},
        {title: "ORDINE/RESO", value: "order", sortable: false},
        {title: "", value: "id", sortable: false},
      ],
      sessioniServer: [],
      loading: true,
      filterOrdini: true,
      filterResi: true,
      options: [10, 20, 30, 40, 50],
      dataCreazione: null,
      dataRicezione: null,
      aperta: true,
      sortBy: [{key: "dataCreazione", order: "desc"}],
      editDataRicezioneDialog: false,
      editDataRicezioneValue: null,
      editDiscordanzeDialog: false,
      editDiscordanzeValue: null,
      editExtraOutDialog: false,
      editExtraOutValue: null,
      editingSession: null,
    }

  },
  computed: {
    isAdmin() {
      return this.store.state.global.userData.roles.includes("ROLE_ADMIN");
    },
  },
  methods: {
    backendMessage(error) {
      const data = error?.response?.data;
      return typeof data === "string" && data.length > 0 && data.length < 500
        ? data
        : null;
    },
    searchSessioni() {
      this.itemsPerPage = 10;
      this.currentPage = 1;
      this.loadItems({page: 1, itemsPerPage: 10, sortBy: this.sortBy});
    },
    resetFiltri() {
      this.filterOrdini = true;
      this.filterResi = true;
      this.searchingAwb.text = "";
      this.searchingUtente.text = "";
      this.searchSessioni();
    },
    formatDate(inputDate) {
      if (inputDate === null) {
        return "nessuna data selezionata";
      } else {
        // Parse the input date string
        const date = new Date(inputDate);

        // Get day, month, and year components
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is zero-based
        const year = date.getFullYear();

        // Construct the formatted date string
        const formattedDate = `${day} / ${month} / ${year}`;

        return formattedDate;
      }
    },
    formattaDataOra(date) {
      return this.dateTime
          .fromISO(date + "Z")
          .setZone("Europe/Rome")
          .setLocale("it")
          .toFormat("dd/MM/yyyy | HH:mm:ss");
    },
    async loadItems({page, itemsPerPage, sortBy}) {
      this.loading = true;

      let filters = {
            ordini: this.filterOrdini,
            resi: this.filterResi,
            awb: this.searchingAwb.text != null ? this.searchingAwb.text.trim() : "",
            userMail: this.searchingUtente.text != null ? this.searchingUtente.text.trim() : "",
            dataCreazione: this.dataCreazione == null
                ? null
                : DateTime.fromJSDate(this.dataCreazione)
                    .setZone("Europe/Rome")
                    .toFormat("yyyy-MM-dd"),
            dataRicezione: this.dataRicezione == null
                ? null
                : DateTime.fromJSDate(this.dataRicezione)
                    .setZone("Europe/Rome")
                    .toFormat("yyyy-MM-dd"),
            aperta: this
                .aperta,
          }
      ;
      console.log(sortBy, page, itemsPerPage, filters);

      const apiUrl = `${this.$apiBaseUrl}/session/allSessions`;
      const bearerToken = this.$keycloak.token;
      console.log(bearerToken);

      const config = {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      };

      let urlParams = {
        filtro: filters,
        sortBy: sortBy[0],
        page: page - 1,
        itemsPage: itemsPerPage,
      };
      console.log(urlParams);

      try {
        const response = await axios.post(apiUrl, urlParams, config);
        console.log(response.data);
        this.sessioniServer = response.data.sessionList;
        this.totalItems = response.data.length;
      } catch (error) {
        console.error(error);
        this.sessioniServer = [];
        this.totalItems = 0;
        Swal.fire({
          icon: "error",
          title: "Errore",
          text: this.backendMessage(error) ?? "Errore nel caricamento delle sessioni",
        });
      }

      this.loading = false;
    },
    async exportExcel() {
      this.store.dispatch("setSnackbarText", "ESPORTAZIONE EXCEL IN CORSO");
      this.store.dispatch("toggleSnackBar", true);
      const url = `${this.$apiBaseUrl}/export/session`;
      const config = {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
        responseType: "blob",
      };

      let filters = {
        ordini: this.filterOrdini,
        resi: this.filterResi,
        awb: this.searchingAwb.text != null ? this.searchingAwb.text.trim() : "",
        userMail: this.searchingUtente.text != null ? this.searchingUtente.text.trim() : "",
        dataCreazione: this.dataCreazione == null
            ? null
            : DateTime.fromJSDate(this.dataCreazione)
                .setZone("Europe/Rome")
                .toFormat("yyyy-MM-dd"),
        dataRicezione: this.dataRicezione == null
            ? null
            : DateTime.fromJSDate(this.dataRicezione)
                .setZone("Europe/Rome")
                .toFormat("yyyy-MM-dd"),
        aperta: this.aperta,
      };

      let urlParams = {
        filtro: filters,
        sortBy: this.sortBy[0],
        page: 1,
        itemsPage: -1,
      };

      try {
        const response = await axios.post(url, urlParams, config);
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(response.data);
        link.download = "session.csv";
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(link.href);
        document.body.removeChild(link);
      } catch (error) {
        console.error("Error:", error.message);
        Swal.fire({
          title: "ERRORE",
          text: this.backendMessage(error) ?? `C'è stato un errore nel caricamento del file excel`,
          icon: "error",
        });
      }
      this.store.dispatch("toggleSnackBar", false);
    },
    openEditDataRicezione(item) {
      this.editingSession = item;
      this.editDataRicezioneValue = item.dataRicezione
          ? DateTime.fromISO(item.dataRicezione + "Z").setZone("Europe/Rome").toJSDate()
          : null;
      this.editDataRicezioneDialog = true;
    },
    async saveDataRicezione() {
      const apiUrl = `${this.$apiBaseUrl}/session/admin/dataRicezione`;
      const config = {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      };
      const payload = {
        sessionId: this.editingSession.id,
        dataRicezione: DateTime.fromJSDate(this.editDataRicezioneValue)
            .setZone("Europe/Rome")
            .toFormat("yyyy-MM-dd"),
      };
      try {
        await axios.put(apiUrl, payload, config);
        this.editDataRicezioneDialog = false;
        this.loadItems({page: 1, itemsPerPage: this.itemsPerPage, sortBy: this.sortBy});
        Swal.fire({
          icon: "success",
          title: "Aggiornato",
          text: "Data ricezione aggiornata con successo",
          timer: 2000,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Errore",
          text: this.backendMessage(error) ?? "Errore nell'aggiornamento della data ricezione",
        });
      }
    },
    openEditDiscordanze(item) {
      this.editingSession = item;
      this.editDiscordanzeValue = item.discordanze;
      this.editDiscordanzeDialog = true;
    },
    async saveDiscordanze() {
      const apiUrl = `${this.$apiBaseUrl}/session/admin/discordanze`;
      const config = {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      };
      const payload = {
        sessionId: this.editingSession.id,
        discordanze: this.editDiscordanzeValue,
      };
      try {
        await axios.put(apiUrl, payload, config);
        this.editDiscordanzeDialog = false;
        this.loadItems({page: 1, itemsPerPage: this.itemsPerPage, sortBy: this.sortBy});
        Swal.fire({
          icon: "success",
          title: "Aggiornato",
          text: "Discordanze aggiornate con successo",
          timer: 2000,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Errore",
          text: this.backendMessage(error) ?? "Errore nell'aggiornamento delle discordanze",
        });
      }
    },
    openEditExtraOut(item) {
      this.editingSession = item;
      this.editExtraOutValue = item.extraOut;
      this.editExtraOutDialog = true;
    },
    async saveExtraOut() {
      const apiUrl = `${this.$apiBaseUrl}/session/admin/extraOut`;
      const config = {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      };
      const payload = {
        sessionId: this.editingSession.id,
        extraOut: this.editExtraOutValue,
      };
      try {
        await axios.put(apiUrl, payload, config);
        this.editExtraOutDialog = false;
        this.loadItems({page: 1, itemsPerPage: this.itemsPerPage, sortBy: this.sortBy});
        Swal.fire({
          icon: "success",
          title: "Aggiornato",
          text: "Extra out aggiornato con successo",
          timer: 2000,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Errore",
          text: this.backendMessage(error) ?? "Errore nell'aggiornamento di extra out",
        });
      }
    },
    openDetails(id) {
      this.store.dispatch("changeBodyClass", "formOpen");
      this.store.dispatch("showContenutoSessione", id);
    },
  },
}
</script>

<style scoped>
.filters-actions-container {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  width: 100%;
}

.filters {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  column-gap: 10px;
  width: fit-content;
}

.v-btn--variant-outlined {
  border: thin solid #d0d0d0;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
}

.v-text-field--variant-outlined {
  border: thin solid #d0d0d0;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
}

.v-field--variant-outlined {
  border: thin solid #d0d0d0;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
}

.v-input {
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2) !important;
  border-radius: 5px !important;
}

.v-list-item--active {
  background-color: #2196f3;
  color: white;
}
</style>